export const previousLabel = (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <g clipPath="url(#clip0_1_1581)">
      <path d="M10.5 12L6.5 8L10.5 4" stroke="#292929" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1_1581">
        <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 -1 16.5 16)" />
      </clipPath>
    </defs>
  </svg>
);

export const nextLabel = (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <g clipPath="url(#clip0_1_1590)">
      <path d="M6.5 4L10.5 8L6.5 12" stroke="#292929" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1_1590">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
